import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { OverviewComponent } from './overview.component';
import { OverviewService } from './overview.service';

import { SharedComponentModule } from '../../shared-components/shared-components.module';

import { OverviewRoutingModule } from './overview-routing.module';
import { BaseService } from "../../shared-service/base.service";
import { ProfilewidgetComponent } from './profilewidget/profilewidget.component';
import { UpcomingtrainingsComponent } from './upcomingtrainings/upcomingtrainings.component';
import { TimelineComponent } from './timeline/timeline.component';
import { MytasksComponent } from './mytasks/mytasks.component';
import { SuggestedcourseComponent } from './suggestedcourse/suggestedcourse.component';
import { UpcomingeventComponent } from './upcomingevent/upcomingevent.component';
import { CustomizePanelComponent } from './customize-panel/customize-panel.component';
import { SettingPanelComponent } from './settings-panel/settings-panel.component';
import { SettingsComponent } from './settings/settings.component';
import { TimeLineConversationComponent } from './timeline-conversation/timeline-conversation.component';

@NgModule({
    imports: [
        CommonModule,
        OverviewRoutingModule,
        SharedComponentModule
    ],
    declarations: [
        OverviewComponent,
        ProfilewidgetComponent,
        UpcomingtrainingsComponent,
        TimelineComponent,
        MytasksComponent,
        SuggestedcourseComponent,
        UpcomingeventComponent,
        CustomizePanelComponent,
        SettingPanelComponent,
        SettingsComponent,
        TimeLineConversationComponent
    ],
    exports: [ProfilewidgetComponent, TimelineComponent],
    entryComponents: [
        UpcomingtrainingsComponent,
        TimelineComponent,
        UpcomingeventComponent,
        MytasksComponent,
        CustomizePanelComponent,
        SettingPanelComponent
    ],
    providers: [OverviewService]
})
export class OverviewModule {
    constructor(private bs: BaseService) {
        this.bs.log('info', "Loaded OverviewModule");
    }
}
